/**
 * @param {import('konva').Node | null} p
 */
function isEditorElementGroup(p) {
  if (!p) return false;
  if (p.getClassName?.() === 'Layer' || p.getClassName?.() === 'Stage') return false;
  if (p.getAttr?.('id') === 'canvas_bg') return false;
  if (typeof p.hasName === 'function' && p.hasName('elementGroup')) return true;
  const raw = p.attrs?.name;
  if (typeof raw === 'string' && raw.split(/\s+/).includes('elementGroup')) return true;
  return false;
}

/**

 * @param {import('konva').Node} node
 * @param {Set<import('konva').Node>} selectedSet
 * @param {import('konva').Stage} stage
 * @returns {{ x: number, y: number, width: number, height: number } | null}
 */
function findAncestorElementGroupRect(node, selectedSet, stage) {
  let p = node.parent;
  while (p) {
    const cls = p.getClassName?.();
    if (cls === 'Layer' || cls === 'Stage') break;
    if (p.getAttr?.('id') === 'canvas_bg') {
      p = p.parent;
      continue;
    }
    if (selectedSet.has(p)) {
      p = p.parent;
      continue;
    }
    if (isEditorElementGroup(p)) {
      return p.getClientRect({ relativeTo: stage });
    }
    p = p.parent;
  }
  return null;
}

const rectKey = (r) =>
  [r.x, r.y, r.width, r.height].map((x) => Math.round(x * 100) / 100).join('|');

/**
 * @param {import('konva').Node[]} nodes 
 * @param {import('konva').Stage} stage
 * @returns {{ x: number, y: number, width: number, height: number } | null}
 */
export function getParentContainerRectForSelection(nodes, stage) {
  if (!nodes?.length || !stage) return null;
  const selectedSet = new Set(nodes);

  const rects = nodes
    .map((n) => findAncestorElementGroupRect(n, selectedSet, stage))
    .filter(Boolean);
  if (!rects.length) return null;
  const k0 = rectKey(rects[0]);
  if (!rects.every((r) => rectKey(r) === k0)) return null;
  return rects[0];
}
